var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screenModel"},[_c('div',{staticClass:"foot"},[_c('div',{staticClass:"flex"},[_c('p',[_vm._v("版权所有 © 安东石油技术（集团）有限公司        测试版")])])])])
}]

export { render, staticRenderFns }